import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import viewIcon from "../../assets/images/icons/eye.svg";
import { Link } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { UI_CONSTANTS } from "../../utils/constants";
import editImage from "../../assets/images/icons/edit-2.svg";

function FormMaster() {
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);


  const getForms = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("page", currentPage.toString());
      params.append("limit", limit.toString());
      if (searchTerm) {
        params.append("search", searchTerm);
      }

      const response = await handleApiCall("get", `${endpoints.formMasterList}?${params.toString()}`);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const responseData = response?.data?.data;
        const formsData = Array.isArray(responseData?.form)
          ? responseData.form
          : Array.isArray(responseData?.forms)
          ? responseData.forms
          : Array.isArray(responseData?.data)
          ? responseData.data
          : Array.isArray(responseData)
          ? responseData
          : [];

        setForms(formsData);
        setTotalPages(responseData?.totalPages || responseData?.pagination?.totalPages || 1);
      } else if (response?.error) {
        console.error("Error fetching forms:", response?.message);
        setForms([]);
      } else {
        setForms([]);
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, limit, searchTerm]);

  useEffect(() => {
    getForms();
  }, [getForms]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusToggle = async (itemId, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;
      setStatusUpdatingId(itemId);

      const response = await handleApiCall("put", endpoints.updateFormMasterStatus, {
        form_master_id: itemId,
        status: newStatus,
      });

      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success("Form status updated successfully!");
        getForms();
      } else if (response?.error) {
        console.error("Error updating form status:", response?.message);
      }
    } catch (error) {
      console.error("Error updating form status:", error);
    } finally {
      setStatusUpdatingId(null);
    }
  };


  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-4 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Form Master</h3>
              <Link to="/add-form-master" className="btn btn-primary rounded-2 px-3 ml-auto">
                {UI_CONSTANTS.BUTTON_LABELS.CREATE_NEW} <span className="ml-2">+</span>
              </Link>
            </div>

            {/* Search Bar */}
            {/* <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control search-icon left-icon border"
                    placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div> */}

            <div className="table-responsive px-0">
              <table className="table table-striped trim">
                 <thead>
                   <tr>
                     <th width="80">{UI_CONSTANTS.TABLE_HEADERS.SR_NO}</th>
                     <th width="150">Question</th>
                     <th width="150">Selection Type</th>
                     <th>{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                     <th className="text-center">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                   </tr>
                 </thead>
                <tbody>
                   {loading ? (
                     <tr>
                       <td colSpan="5" className="text-center py-4">
                         <div className="spinner-border" role="status">
                           <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
                         </div>
                       </td>
                     </tr>
                   ) : !Array.isArray(forms) || forms.length === 0 ? (
                     <tr>
                       <td colSpan="5" className="text-center py-4">
                         {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                       </td>
                     </tr>
                  ) : (
                    forms.map((item, index) => {
                      const itemId = item._id || item.id || item.form_master_id || `form-${index}`;
                      const question = item.question_en || item.question_english || "";
                      const status = item.status ?? 0;
                      const selectionType = item.type || item.selection_type || item.selectionType || "";
                      const selectionTypeDisplay = selectionType === "checkbox" ? "Checkbox" : selectionType === "single_selection" ? "Single selection" : selectionType || "N/A";

                      return (
                         <tr key={itemId}>
                           <td>{(currentPage - 1) * limit + index + 1}</td>
                           <td className="text-center">{question || UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}</td>
                           <td className="text-center">{selectionTypeDisplay}</td>
                           <td>
                            <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                checked={status === 1}
                                onChange={() => handleStatusToggle(itemId, status)}
                                disabled={statusUpdatingId === itemId}
                              />
                              <span className="custom-control-label custom-toggle" />
                            </label>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              <Link to={`/view-form-master/${itemId}`} className="btn btn-link p-0 mx-2" title={UI_CONSTANTS.BUTTON_LABELS.VIEW || "View"}>
                                <img src={viewIcon} alt={UI_CONSTANTS.BUTTON_LABELS.VIEW || "View"} style={{ width: 20, height: 20, filter: "brightness(0) invert(1)", opacity: 0.95 }} className="mr-2" />
                              </Link>
                              <Link to={`/edit-form-master/${itemId}`} className="btn btn-link p-0 mx-2">
                                <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        {UI_CONSTANTS.BUTTON_LABELS.PREVIOUS || "Previous"}
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        {UI_CONSTANTS.BUTTON_LABELS.NEXT || "Next"}
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormMaster;
